import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
/**
 * Update the UserOptions navigation bar width, width ratio
 * @param width the navigation bar width
 * @return a promise which contains UpdateUserConfigurationJsonResponse
 */
export default function updateNavigationBarWidth(width) {
    return updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['NavigationBarWidth'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: ["" + width],
            }),
        }),
    ]);
}
//# sourceMappingURL=updateNavigationBarWidth.js.map